import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { injectIntl } from 'react-intl';
import EnumCacheService from '@/shared/services/EnumCacheService';
import intlShape from '@/shared/utils/intlShape';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';

const EnumMultiSelect = ({
  type,
  sortById,
  selection,
  onChange,
  intl,
  placeholder,
  customItems,
  itemMapper,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    EnumCacheService.getTranslated(type, intl, sortById).then(values => {
      if (mounted) {
        setItems(typeof itemMapper === 'function' ? itemMapper(values) : values);
      }
    });

    return () => {
      mounted = false;
    };
  }, [intl, type, sortById]);

  const allItems = [...customItems, ...items];

  const [selectedItems, selectableItems] = splitItems(allItems, selection);

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item))}
      onItemSelected={item => onChange(addItem(selection, item))}
      items={selectableItems}
      placeholder={placeholder}
    />
  );
};
EnumMultiSelect.propTypes = {
  type: PropTypes.string.isRequired,
  selection: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
  sortById: PropTypes.bool,
  customItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
    }),
  ),
  itemMapper: PropTypes.func,
};
EnumMultiSelect.defaultProps = {
  selection: [],
  placeholder: null,
  sortById: false,
  customItems: [],
  itemMapper: undefined,
};

export default injectIntl(EnumMultiSelect);
